import React from "react";
import ReactDOM from "react-dom/client";
import App, { preloadPrerendered } from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "styled-components";
import { GlobalStyles, lightTheme, darkTheme } from "./styles/Global";

import "./i18n";
import { BrowserRouter } from "react-router-dom";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

// A page prerendered at build time (scripts/prerender.js) arrives with its content in #root and with its own
// <title> and meta description. Put the site defaults back, so the page's usePageMeta restores those (not the
// page's own) when the visitor navigates on, and load the page's code first, so React replaces the saved
// markup with the same page in one step.
const prerendered = container.hasChildNodes();
if (prerendered) {
    document.querySelectorAll("title[data-default], meta[data-default]").forEach((el) => {
        if (el.tagName === "TITLE") {
            document.title = el.getAttribute("data-default");
        } else {
            el.setAttribute("content", el.getAttribute("data-default"));
        }
        el.removeAttribute("data-default");
    });
}

const storedTheme = localStorage.getItem("theme");
const initialTheme = storedTheme === "light" ? lightTheme : darkTheme;

const render = () => root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ThemeProvider theme={initialTheme}>
                <GlobalStyles />
                <App />
            </ThemeProvider>
        </BrowserRouter>
    </React.StrictMode>
);

if (prerendered) {
    // If the chunk fails to load, render anyway: the route's error boundary handles it as on any other visit.
    preloadPrerendered(window.location.pathname).then(render, render);
} else {
    render();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
